export default "__VITE_ASSET__8d1e070e__"